import Axios from "axios";
import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface Props {
	id: string | number;
}
const FileButton: FC<Props> = ({ id }) => {
	const { register, watch, setValue } = useFormContext();
	const { t } = useTranslation();
	const ref = useRef<HTMLInputElement>(null);
	const images = watch(`image`);
	const [image, setImage] = useState(null);
	const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
	const [progress, setProgress] = useState(0);

	/**
	 * react-hook-form images 객체가 변하면
	 * image state 변경
	 */
	useEffect(() => {
		if (images) {
			setImage(images[id]);
		}
	}, [id, images]);

	/**
	 * 이미지가 변경되면
	 */
	const handleImageChange = useCallback(
		(url) => {
			setValue(`image[${id}]`, url);
			setProgress(0);
		},
		[id, setValue],
	);

	const handleFileChange = useCallback(() => {
		if (ref && ref.current) {
			const fileInput = ref.current;
			const files = fileInput.files || [];

			const file = files[0];
			if (!validImageTypes.includes(file.type)) {
				alert(t("올바른 파일 형식이 아닙니다.\n파일 확장명이 JPG, GIF 인지 다시 확인해주세요."));
				return false;
			}

			if (file.type !== "image/gif" && file.size > 10 * 1024 * 1024) {
				alert(t("파일 용량이 10MB을(를) 초과하여 등록할 수 없습니다."));
				return false;
			} else if (file.type === "image/gif" && file.size > 1024 * 200) {
				alert(t("선택하신 GIF 파일 용량이 200KB를 초과하여 등록할 수 없습니다. 파일 용량을 다시 확인해주세요."));
				return false;
			}

			const data = new FormData();
			data.append("file", file);

			Axios({
				method: "post",
				data,
				url: `//bjapi.afreecatv.com/api/vote/upload`,
				withCredentials: true,
				onUploadProgress: (progressEvent) => {
					var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
					setProgress(percentCompleted);
				},
			}).then(
				(response) => {
					handleImageChange(response.data.url);
					//초기화
					if (ref.current) {
						ref.current.value = "";
					}
				},
				(error) => {
					handleImageChange(null);
				},
			);
		}
	}, [handleImageChange, t, validImageTypes]);
	/**
	 * 파일선택 클릭
	 */

	const handleFileClick = useCallback((e) => {
		e.stopPropagation();
		if (ref.current) {
			ref.current.click();
		}
	}, []);

	return (
		<>
			{image ? (
				<div
					className="img"
					style={{
						backgroundImage: `url(${image})`,
					}}
				>
					<button type="button" className="btn_imgDel" onClick={() => handleImageChange(null)}>
						<span>이미지 삭제</span>
					</button>
				</div>
			) : (
				<>
					{progress ? (
						<span className="progress">
							<em style={{ width: `${progress}%` }}></em>
						</span>
					) : (
						<button type="button" className="btn_file" onClick={handleFileClick}>
							이미지 첨부
						</button>
					)}
				</>
			)}
			<input type="hidden" name={`image[${id}]`} ref={register} />
			<input type="file" name="file" ref={ref} style={{ position: "absolute", width: 0 }} onChange={handleFileChange} />
		</>
	);
};

export default FileButton;
